// extracted by mini-css-extract-plugin
module.exports = {"menu":"FqdvIsHBPvZbq6wtpG4k"};